<template>
    <div id="v-login-wrap" :style="{width:windowWidth,height:windowHeight}">
        <dl>
            <dt>
                <div class="exterior">
                    <h5>登录到利元亨</h5>
                    <div class="row">
                        <p>账号（手机号）</p>
                        <div class="inp_box">
                            <input type="text" class="inp" placeholder="请输入手机号" v-model="mobile" />
                        </div>
                    </div>
                    <div class="row">
                        <p>公司名（公司全称）</p>
                        <div class="inp_box">
                            <input type="text" class="inp" placeholder="请输入公司名"  v-model="company_name" />
                        </div>
                    </div>
                    <div class="row">
                        <p>验证码</p>
                        <div class="inp_box">
                            <input type="text" class="inp" placeholder="请输入验证码" v-model="code" />
                            <img @click="onFlush" class="CAPTCHA" :src="picture" alt="">
                        </div>
                    </div>
                    <div class="row">
                        <p>登录</p>
                        <div class="btn" @click="onEnter">登录</div>
                    </div>
                </div>
            </dt>
            <dd>
                <img class="logo" :src="$config.resource + 'logo.png'" alt="">
                <img class="pic_bg" :src="$config.resource + 'dlbj.png'" alt="">
            </dd>
        </dl>
    </div>
</template>
<script>

    import store from '../vuex/store.js';
    export default {
        data(){
            return{
                mobile:'',//账号（手机号）
                company_name:'',//公司名（公司全称）
                code:'',//输入验证码
                key:'',//验证码
                picture:'',//验证码
                windowWidth: document.documentElement.clientWidth,  //实时屏幕宽度
                windowHeight: document.documentElement.clientHeight,   //实时屏幕高度
            }
        },
        store,
        methods: {
            //页面跳转
            toViewPage($path,$query) {
                this.$jump.toViewPage(this,$path,$query)
            },
            //获取验证码
            getCAPTCHA(){
                const that = this
                that.$request({
                    that: that,
                    api: that.$api.captcha,
                    data: {},
                    success(res) {
                       that.picture = res.data.base64 
                       that.key = res.data.key
                    }
                })
            },
            // 刷新验证码
            onFlush(){
                const that = this
                that.getCAPTCHA()//验证码
            },
            // 登录
            onEnter(){
                const that = this
                that.$request({
                    that: that,
                    api: that.$api.login,
                    data: {
                        mobile:that.mobile,
                        company_name:that.company_name,
                        code:that.code,
                        key:that.key
                    },
                    success(res) {
                       //存储用户登录凭证
                            that.$storage.set('accesstoken',res.data.token)

                            //登录成功发起页面跳转
                            that.$dialog.toast({
                                mes: '登录成功',
                                timeout: 1500,
                                icon: 'success',
                                callback(){
                                    that.$router.push({ path: '/Index' })
                                }
                            })
                    },
                    fail(err){
                        that.key = ''
                        that.code = ''
                        that.getCAPTCHA()
                    }
                })
            },
        },
        mounted() {
            const that = this
            that.$store.commit('EditPageData',this.PageData)
            that.getCAPTCHA()//验证码
            
        },
        components:{
            
        },
    }
</script>


// WEBPACK FOOTER //
// src/page/logIn.vue